import { Alert, Box, Button, Container, Snackbar, TextField, Typography } from "@mui/material";
import { useState } from "react";

function GetInTouch() {

    const [responseM, setResponseM] = useState({
        'message': '',
        'severity': ''
    });

    const handleClose = () => {
        setResponseM({
            'message' : '',
            'severity': ''
        })
    }

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const handleChange = (e) => {
        const {name, value} = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const sendInbox = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://nutriedu.com.ng/api/v1/contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const result = await response.json();

            if (result.success) { 
                
                setFormData({
                    name: '',
                    email: '',
                    message: ''
                });

                setResponseM({
                    message: 'We\'ll be in touch with you',
                    severity: 'success'
                });
            }
            else {
                setResponseM({
                    message: 'an error occured',
                    severity: 'error'
                });
            }

        } catch (error) {
            setResponseM({
                message: 'an error occured',
                severity: 'error'
            });
        }
        
    };

    return (
        <Container id="contact" sx={{ marginTop: 5, backgroundColor: "#dce6e6" }}>
            {/* Title */}
            <Typography
                variant="h5"
                sx={{
                    fontFamily: 'Fredoka One, sans-serif',
                    color: 'grey.800',
                    marginBottom: 3,
                    paddingTop: 2,
                    textAlign: 'center'
                }}
            >
                Get In Touch
            </Typography>
            
             {/* Form Container */}
             <form
                action="https://formspree.io/f/xvgzrgvn"
                method="post"
             >
                <Box 
                    sx={{ 
                        maxWidth: 'sm', 
                        margin: '0 auto', 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: 2 
                    }}
                >
                    {/* Name Input */}
                    <TextField
                        variant="outlined"
                        name="name"
                        label="Name"
                        required
                        fullWidth
                        sx={{
                            backgroundColor: '#fff',
                            color: '#727272',
                        }}
                    />
                    
                    {/* Email Input */}
                    <TextField
                        variant="outlined"
                        name="email"
                        label="Email Address"
                        type="email"
                        required
                        fullWidth
                        sx={{
                            backgroundColor: '#fff',
                            color: '#727272',
                        }}
                    />
                    
                    {/* Message Input */}
                    <TextField
                        variant="outlined"
                        name="message"
                        label="Your Message"
                        multiline
                        rows={4}
                        required
                        fullWidth
                        sx={{
                            backgroundColor: '#fff',
                            color: '#727272',
                        }}
                    />

                    {/* Submit Button */}
                    <Box sx={{ display: 'flex', justifyContent: 'end', paddingBottom: 2 }}>
                        <Button
                            variant="contained" 
                            sx={{ 
                                background: 'linear-gradient(90deg,rgb(114, 129, 202),rgb(19, 184, 175))',
                                padding: '10px 20px',
                                textTransform: 'none',
                                fontSize: '1rem',
                                borderRadius: 2,
                            }}
                            type="submit"
                        >
                            Send Message
                        </Button>
                    </Box>
                </Box>
             </form>

            {
                responseM['message'] && 

                <Snackbar
                    open={true}
                    autoHideDuration={5000}
                    onClose={handleClose}
                >
                    <Alert
                        onClose={handleClose}
                        severity={responseM['severity']}
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {responseM['message']}
                    </Alert>
                </Snackbar>
            }
            
        </Container>
    );
}

export default GetInTouch;
